import { handleActions } from 'redux-actions';
import RequestState, { States, NOT_REQUESTED, REQUESTED, SUCCEEDED } from 'forms-utils-lib/RequestState';
import { FAIL_GETTING_FLOW_USAGES, RECEIVE_FLOW_USAGES, REQUEST_FLOW_USAGES } from 'ui-forms-editor-automation-lib/actions/fetchFlowUsages';
import { UPDATE_FLOW_USAGES } from 'ui-forms-editor-automation-lib/actions/updateFlowUsages';
import { UPDATE_FLOW_USAGES_PENDING } from 'ui-forms-editor-automation-lib/actions/updateFlowUsages';
export const INITIAL_STATE = {
  flows: [],
  error: {},
  requestState: NOT_REQUESTED
};
export default handleActions({
  [REQUEST_FLOW_USAGES]: () => ({
    flows: [],
    requestState: REQUESTED,
    error: {}
  }),
  [UPDATE_FLOW_USAGES_PENDING]: state => {
    return Object.assign({}, state, {
      requestState: REQUESTED,
      error: {}
    });
  },
  [UPDATE_FLOW_USAGES]: (state, {
    payload
  }) => {
    return Object.assign({}, state, {
      flows: [...payload],
      requestState: SUCCEEDED,
      error: {}
    });
  },
  [RECEIVE_FLOW_USAGES]: (state, {
    payload
  }) => {
    const flows = payload.map(flow => ({
      id: flow.flowId,
      isExternalLink: flow.isExternalFlow
    }));
    return Object.assign({}, state, {
      flows,
      requestState: SUCCEEDED,
      error: {}
    });
  },
  [FAIL_GETTING_FLOW_USAGES]: (state, {
    payload
  }) => Object.assign({}, state, {
    flows: [],
    requestState: new RequestState({
      state: States.FAILED,
      error: payload
    }),
    error: payload
  })
}, INITIAL_STATE);